<template>
  <el-dialog class="dialog-container" @close="handleClose" title="兑换核销" :visible.sync="dialogVisible">
    <div class="dialog-search-btn">
      <el-input v-model="value" clearable placeholder="请输入核销码"></el-input>
      <el-button type="primary" icon="el-icon-search" @click="clickSearch" size="medium">查询</el-button>
    </div>
    <template v-if="isShowInfo">
      <el-divider content-position="left">兑换信息</el-divider>
      <span v-if="memberInfo.member_name !==''" style="margin-left:85px;" class="span-divider">姓名：{{memberInfo.member_name}}</span>
      <span v-else style="margin-left:85px;" class="span-divider">姓名：{{memberInfo.member_wxname}}</span>
      <span class="span-divider">ID：{{memberInfo.member_mid}}</span>
      <span class="span-divider">手机号：{{memberInfo.member_mobile}}</span><br />
      <span class="span-divider" style="margin-left:85px;margin-top:15px;"><img width="60" :src="memberInfo.goods_coverimg"/></span><br />
      <span class="span-divider" style="margin-left:85px;margin-top:15px;">商品名称：{{memberInfo.goods_title}}</span><br />
      <span class="span-divider" style="margin-left:85px;margin-top:15px;">使用积分：{{memberInfo.costpoints}}</span><br />
      <span class="span-divider" style="margin-left:85px;margin-top:15px;">兑换时间：{{memberInfo.createtime}}</span><br />
      <span class="span-divider" style="margin-left:85px;margin-top:15px;">有效期：{{memberInfo.starttime === memberInfo.endtime ? '永久有效' : `${memberInfo.starttime} - ${memberInfo.endtime}`}}</span><br />
      <span class="span-divider" style="margin-left:85px;margin-top:15px;">核销状态：{{changeStatus(memberInfo.status )}}</span>
    </template>
    <span slot="footer" class="dialog-footer">
      <el-checkbox v-if="isShowInfo" style="margin-right:20px;" v-model="checked">确认信息</el-checkbox>
      <el-button type="primary" :disabled="!checked" @click="handleVerifyAffirm">核 销</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { exchangeSearch, exchangeVerify } from '@/views/webpc/CreditMall/ExchangeListApp/apis'
export default {
  data () {
    return {
      value: '',
      checked: false,
      memberInfo: {},
      isShowInfo: false,
      dialogVisible: false
    }
  },
  methods: {
    show () {
      this.dialogVisible = true
    },
    // 状态转换
    changeStatus (status) {
      status = parseInt(status)
      switch (status) {
        case 0:
          return '未核销'
        case 1:
          return '已核销'
        default:
          return '其他'
      }
    },
    // 核销
    getHandleVerify () {
      let data = new FormData()
      data.append('cdkey', this.memberInfo.cdkey)
      exchangeVerify(data)
        .then(result => {
          if (result) {
            this.dialogVisible = false
            this.$message({
              type: 'success',
              message: '操作成功!'
            })
            this.$emit('ok')
          }
        })
    },
    // 核销触发
    handleVerifyAffirm () {
      this.$confirm('确认核销, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.getHandleVerify()
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    },
    // 查询信息
    clickSearch () {
      this.memberInfo = {}
      this.isShowInfo = false
      this.checked = false
      if (this.value === '') {
        this.$message({
          type: 'warning',
          message: '请输入核销码'
        })
        return
      }
      let data = new FormData()
      data.append('cdkey', this.value)
      exchangeSearch(data)
        .then(result => {
          if (result) {
            if (result.data) {
              this.isShowInfo = true
              this.memberInfo = result.data
            } else {
              this.$confirm('查无数据，请确认输入核销码是否正确！', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
              }).catch(() => {
              })
            }
          }
        })
    },
    handleClose () {
      this.value = ''
      this.checked = false
      this.memberInfo = {}
      this.isShowInfo = false
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/webpc/CreditMall/ExchangeListApp/modules/verifyModal.vue